import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-extent",
  "use": "icon-extent-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-extent\"><path d=\"M163.84 0h696.32Q1024 0 1024 163.84v696.32Q1024 1024 860.16 1024H163.84Q0 1024 0 860.16V163.84Q0 0 163.84 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol